<template>
  <v-layout id="app-contact" xs12 justify-center row align-center class="app-contact">
		<v-flex md4 xs8>
			<v-flex class="name-contactanos">CONTÁCTANOS</v-flex>
			<v-layout class="content-information" row align-center v-for="(item, index) in information" :key="index">
				<img :src="item.icon" alt="" width="20">
				<p class="item-information">{{ item.name }}</p>
			</v-layout>
		</v-flex>
		<v-flex xs12 md4 class="content-form">
			<form-contact
			/>
		</v-flex>
	</v-layout>
</template>

<script>
import formContact from '@/components/home/form-contact';

export default {
	name: 'app-contact',
	components: {
		formContact,
	},
	props: {
		information: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.name-contactanos {
	color: map-get($colors, blue-regular);
	font-family: 'Lato', sans-serif;
	font-weight: 900;
	font-size: 40px;
	margin-bottom: 68px;

	@media (max-width: 1024px) {
		font-size: 30px;
		margin-bottom: 43px;
		text-align: center;
	}
}

.app-contact {
	background-color: map-get($colors, white);
	position: relative;

	@media (max-width: 1024px) {
		flex-direction: column;
		padding-top: 59px;
	}
}

.item-information {
	color: map-get($colors, blue-regular);
	font-family: 'Lato', sans-serif;
	font-weight: 300;
	font-size: 20px;
	margin: 0 0 0 14px;
	width: 300px;

	@media (max-width: 1024px) {
		text-align: center;
	}
}

.content-information {
	margin-bottom: 35px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/app-contact.vue